import * as Url from "../Url";
import * as Services from "../handler";

export interface MoreAppItem {
  app_name: string;
  app_logo: string;
  app_link: {
    android?: string;
    ios?: string;
  };
}

export async function getMoreApps(
  json_name: string = "english",
  appName: string = ""
): Promise<MoreAppItem[]> {
  try {
    const query = `?json_name=${encodeURIComponent(json_name)}&app_name=${encodeURIComponent(appName)}`;
    const res = await Services.GET(`${Url.MORE_APPS}${query}`);

    const responseData = res?.data;
    if (Array.isArray(responseData?.data?.apps)) {
      return responseData.data.apps;
    }
    if (Array.isArray(responseData?.apps)) {
      return responseData.apps;
    }
    if (Array.isArray(responseData?.data)) {
      return responseData.data;
    }
    if (Array.isArray(responseData)) {
      return responseData;
    }

    return [];
  } catch (error) {
    console.error("Error fetching more apps from API:", error);
    return [];
  }
}
